import {
    taskResizeAndUploadImage,
    TASK_RESIZE_AND_UPLOAD_IMAGE,
} from './taskResizeAndUploadImage';

import { GET_TRQK_STATEMENT_VIEWS_FOR_USER_PARTIAL } from './taskQueries';

import {
    taskUploadAudioFileToTrack,
    TASK_UPLOAD_AUDIO_FILE_TO_TRACK,
} from './taskUploadAudioFileToTrack';

import {
    taskUploadAudioFileToTrqkAudio,
    TASK_UPLOAD_AUDIO_FILE_TO_TRQK_AUDIO,
} from './taskUploadAudioFileToTrqkAudio';

import {
    taskUploadDetectionsToTrqkGap,
    TASK_UPLOAD_DETECTIONS_TO_TRQK_GAP,
} from './taskUploadDetectionsToTrqkGap';

import { taskUploadToS3, TASK_UPLOAD_TO_S3 } from './taskUploadToS3';

export const taskMutations = {
    taskResizeAndUploadImage,
    taskUploadAudioFileToTrack,
    taskUploadAudioFileToTrqkAudio,
    taskUploadDetectionsToTrqkGap,
    taskUploadToS3,
};

export const taskQueryStrings = {
    GET_TRQK_STATEMENT_VIEWS_FOR_USER_PARTIAL,
    TASK_RESIZE_AND_UPLOAD_IMAGE,
    TASK_UPLOAD_AUDIO_FILE_TO_TRACK,
    TASK_UPLOAD_AUDIO_FILE_TO_TRQK_AUDIO,
    TASK_UPLOAD_DETECTIONS_TO_TRQK_GAP,
    TASK_UPLOAD_TO_S3,
};
